import { disablePageScroll, enablePageScroll } from "scroll-lock";
import $ from "./main"
require('js-marker-clusterer');

/*=============================================
= Store finder
=============================================*/

var locations = [];
var markers = [];
var infoWindows = [];
var clusterMarkers = [];

var mapStyle = [{
	"elementType": "geometry",
	"stylers": [{
		"color": "#99bfe3"
	}]
},
	{
		"featureType": "administrative",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#337ec6"
		}]
	},
	{
		"featureType": "administrative",
		"elementType": "labels.text.stroke",
		"stylers": [{
			"color": "#ffffff"
		}]
	},
	{
		"featureType": "administrative.country",
		"elementType": "geometry.fill",
		"stylers": [{
			"visibility": "on"
		}]
	},
	{
		"featureType": "administrative.locality",
		"elementType": "labels.icon",
		"stylers": [{
			"color": "#ffffff"
		}]
	},
	{
		"featureType": "landscape",
		"stylers": [{
			"color": "#f0f5fb"
		}]
	},
	{
		"featureType": "poi",
		"stylers": [{
			"visibility": "off"
		}]
	},
	{
		"featureType": "road",
		"stylers": [{
			"saturation": -100
		},
			{
				"lightness": 45
			}
		]
	},
	{
		"featureType": "road.arterial",
		"elementType": "geometry",
		"stylers": [{
			"color": "#ffffff"
		}]
	},
	{
		"featureType": "road.arterial",
		"elementType": "labels.icon",
		"stylers": [{
			"visibility": "off"
		}]
	},
	{
		"featureType": "road.arterial",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#adcbe8"
		}]
	},
	{
		"featureType": "road.highway",
		"elementType": "geometry",
		"stylers": [{
			"color": "#ffffff"
		}]
	},
	{
		"featureType": "road.highway",
		"elementType": "labels.icon",
		"stylers": [{
			"visibility": "off"
		}]
	},
	{
		"featureType": "road.highway",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#adcbe8"
		}]
	},
	{
		"featureType": "road.local",
		"elementType": "geometry",
		"stylers": [{
			"color": "#ffffff"
		}]
	},
	{
		"featureType": "road.local",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#adcbe8"
		}]
	},
	{
		"featureType": "transit",
		"stylers": [{
			"visibility": "off"
		}]
	},
	{
		"featureType": "water",
		"stylers": [{
			"color": "#bdd4ea"
		},
			{
				"visibility": "on"
			}
		]
	}
];


function clearMarkerEffects() {

};

$(".js-store").on("mouseover", function () {
	if(typeof infoWindows[$(this).data("id")] !== "undefined") {
		infoWindows[$(this).data("id")].open();
	}

});

function resetSearch() {
	$(".js-store-finder-input").val("");
};

function updateStoreVisibility() {
	clearMarkerEffects();
	setTimeout(function () {
		if (!($('.js-nothing-currently-on-the-map').hasClass("visuallyhidden"))) {
			$('.js-nothing-currently-on-the-map').addClass("visuallyhidden");
		}

		var foundSomething = false;
		var bounds = window._map.getBounds();
		if (bounds) {
			for (var idx in window._markers) {
				var itm = window._markers[idx];
				if (bounds.contains(itm.position)) {
					foundSomething = true;
					// show stores which are in viewport
					$(`.js-store-${itm.id}`).show();
				} else {
					$(`.js-store-${itm.id}`).hide();
				}
			}
		}


		if (!foundSomething) {
			$('.js-nothing-currently-on-the-map').removeClass("visuallyhidden");
		}
	}, 1000);
};

function drawStoreFinderMap() {
	var myLatlng = new google.maps.LatLng(-41.0276264, 172.2164314);

	// var NEW_ZEALAND_BOUNDS = {
	// 	north: -34.183472,
	// 	south: -46.645672,
	// 	west: 165.884920,
	// 	east: 178.245534,
	// };

	var mapOptions = {
		zoom: 6,
		maxZoom: 18,
		center: myLatlng,
		// restriction: {
		//     latLngBounds: NEW_ZEALAND_BOUNDS,
		//     strictBounds: false,
		// },
		mapTypeControl: false,
		streetViewControl: false,
		fullscreenControl: false,
		scrollwheel: true,
		zoomControl: false,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		styles: mapStyle
	};

	var map = new google.maps.Map(document.getElementById("stores_map"), mapOptions);

	if ($(".js-store").length > 0) {

		const SnazzyInfoWindow = require('snazzy-info-window');

		$(".js-store").each(function (index, itm) {

			let id = $(itm).data('id');
			let lat = $(itm).data('lat');
			let lng = $(itm).data('long');
			let title = $(itm).data('title');
			let address = $(itm).data('address');
			let phone = $(itm).data('phone');
			let image = $(itm).data('image');
			let link = $(itm).data('link');

			let marker = new google.maps.Marker({
				position: new google.maps.LatLng($(this).data('lat'), $(this).data('long')),
				map: map,
				icon: {
					url: '/images/icons/icon--map-pin.svg',
					scaledSize: new google.maps.Size(40, 40)
				},
				id: $(this).data('id')
			});

			google.maps.event.addListener(marker, 'click', function() {
				map.setCenter(marker.getPosition());
			});

			let infoWindow = new SnazzyInfoWindow({
				marker: marker,
				border: false,
				borderRadius: '4px',
				shadow: false,
				closeWhenOthersOpen: true,
				wrapperClass: 'store-info-window',
				// placement: 'left',
				openOnMarkerClick: true,
				panOnOpen: true,
				content:
					'<div class="biw-wrapper">' +
					'<a href="' + link + '">' +
					'<figure class="biw-image"><div class="img-resizer aspect-ratio--4x3"></div><img src="' + image + '" class="object-fit object-cover"></figure>' +
					'<div class="biw-text">' +
					'<h3 class="biw-title">' + title + '</h3>' +
					'<div class="biw-address">' + address + '</div>' +
					'<div class="biw-phone">' + phone + '</div>' +
					'</div>' +
					'</a>' +
					'</div>',
			});

			markers[id] = marker;
			infoWindows[id] = infoWindow;
			let mapMarker = marker;
			clusterMarkers.push(mapMarker);

		});
	}

	// var markerCluster = new MarkerClusterer(map, clusterMarkers, {imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'});
	var markerCluster = new MarkerClusterer(map, clusterMarkers, {imagePath: '/images/icons/clustering/m'});
	markerCluster.setMaxZoom(10);
	markerCluster.setStyles(markerCluster.getStyles().map(function (style) {
		style.width = '48';
		style.height = '48';
		style.textColor = '#fff';
		style.textSize = 17;
		return style;
	}));

	// Change store list on map change
	google.maps.event.addListener(map, 'dragend', function () {
		updateStoreVisibility();
	});
	google.maps.event.addListener(map, 'zoom_changed', function () {
		updateStoreVisibility();
	});

	window._map = map;
	window._markers = markers;
	updateStoreVisibility();

	//Map zoom
	$(document).on('click', '.js-map-in', function () {
		map.setZoom(map.getZoom() + 1);
	});
	$(document).on('click', '.js-map-out', function () {
		map.setZoom(map.getZoom() - 1);
	});
}


/*=============================================
= Store finder - mobile UI
=============================================*/
let storeFinderIsActive = false;
const storeFinderActiveClass = 'store-finder-is-active';
const storeFinderInput = document.querySelector('.js-store-finder-input');
const storeFinderToggle = document.querySelector('.js-store-finder-toggle');

if (storeFinderInput && storeFinderToggle) {
	function storeFinderActivate() {
		storeFinderIsActive = true;
		document.body.classList.add(storeFinderActiveClass);
	}
	function storeFinderDeactivate() {
		storeFinderIsActive = false;
		document.body.classList.remove(storeFinderActiveClass);
	}

	// storeFinderInput.addEventListener('keyup', (event) => {
	// 	if (event.isComposing || event.keyCode === 229) {
	// 		return;
	// 	}

	// 	if (storeFinderInput.value === '') {
	// 		storeFinderDeactivate();
	// 	} else {
	// 		storeFinderActivate();
	// 	}

	// 	//esc
	// 	if (event.keyCode === 27) {
	// 		storeFinderDeactivate();
	// 	}
	// });

	//Toggle store finder panel
	storeFinderToggle.addEventListener('click', (event) => {
		if (storeFinderIsActive) {
			storeFinderDeactivate();
		} else {
			storeFinderActivate();
		}
	});
}

/*=============================================
	= Store detail map
	=============================================*/
function drawStoreDetailMap() {
	var storeMapCoords = new google.maps.LatLng($("#store_detail_map").data("lat"), $("#store_detail_map").data("lng"));

	var storeMapOptions = {
		zoom: 15,
		center: storeMapCoords,
		mapTypeControl: false,
		streetViewControl: false,
		fullscreenControl: false,
		scrollwheel: false,
		zoomControl: false,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		styles: mapStyle
	};

	var storeMap = new google.maps.Map(document.getElementById("store_detail_map"), storeMapOptions);

	var storeMapMarker = new google.maps.Marker({
		position: storeMapCoords,
		map: storeMap,
		icon: {
			url: '/images/icons/icon--map-pin-logo.svg',
			scaledSize: new google.maps.Size(136, 56)
		}
	});

	google.maps.event.addListener(storeMapMarker, "click", function (e) {
		window.open($("#store_detail_map").data("map"));
	});


	//Map zoom
	$(document).on('click', '.js-map-in', function () {
		storeMap.setZoom(storeMap.getZoom() + 1);
	});
	$(document).on('click', '.js-map-out', function () {
		storeMap.setZoom(storeMap.getZoom() - 1);
	});
}

function initLocationsMap() {
	if (document.getElementById('stores_map')) {
		// autocomplete of address

		var adjustMapWithNewCentre = (lat, lng, place) => {
			window._map.setCenter({
				lat: lat,
				lng: lng
			});
			window._map.setZoom(10);
		}

		var updateMapViewport = function (place) {
			var lat = place.geometry.location.lat();
			var lng = place.geometry.location.lng();
			// update map with new centre
			adjustMapWithNewCentre(lat, lng, place);
		};

		var changePlace = function () {
			var place = window._autocomplete.getPlace();
			if (place && place.geometry) {
				updateMapViewport(place);
			} else {
				var firstResult = $(".pac-container .pac-item:first").text();
				var geocoder = new google.maps.Geocoder();
				geocoder.geocode({"address": firstResult}, function (results, status) {
					if (status == google.maps.GeocoderStatus.OK) {
						$(".js-store-finder-input").val(results[0].formatted_address);
						updateMapViewport(results[0]);
					}
				});
			}
		};

		window._autocomplete = new google.maps.places.Autocomplete(document.getElementById('stores_autocomplete'), {
			types: ['(regions)'],
			componentRestrictions: {'country': 'nz'}
		});
		window._autocomplete.addListener('place_changed', changePlace);
		$("#autocomplete").focusin(function () {
			$(document).keypress(function (e) {
				if (e.which == 13) {
					e.preventDefault();
					changePlace();
				}
			});
		});
		$(document).on('touchstart click', '.js-block-find-location-form-find', function () {
			changePlace();
		});

		// autocomplete of address ends

		drawStoreFinderMap();
	}
	if (document.getElementById('store_detail_map')) {
		drawStoreDetailMap();
	}
}

window.initLocationsMap = initLocationsMap;

if (window.location.pathname.includes('/stores')) {
	// Switching to v=3.36 solves this for now, but 3.36 will be removed next update, where it will default to the "v=quarterly" response
	const mapsUrl = '//maps.googleapis.com/maps/api/js?key=AIzaSyASHV71FT9zG4YtH7faSlcDdDOzq8LAghY&callback=initLocationsMap&libraries=places&v=quarterly';
	const mapsScript = document.createElement('script');
	mapsScript.async = true;
	mapsScript.src = mapsUrl;
	document.querySelector('head').appendChild(mapsScript);
}


$(document).ready(function() {

	/**
	 * Contact us page open fancybox
	 */
	if($("#contact_store").length > 0 && window.location.hash == "#contact_store") {

		$.fancybox.open({
			src  : '#contact_store',
			type : 'inline',
			opts : {
				afterShow : function( instance, current ) {
					console.info( 'done!' );
				}
			}
		});

		// console.log();
		// $('#contact_store').fancybox({
		// 	touch : false,
		// 	smallBtn  : false
		// });
	}

})
